import styled from 'styled-components';
import { Box, Text, Tooltip } from '@stashinvest/ui';

export const StyledTooltip = styled(Tooltip)`
	padding: 0 0 0 0.25rem;
	vertical-align: baseline;

	> div {
		min-width: 0;
		min-height: 0;
		max-width: 1rem;
		max-height: 1rem;
	}

	&::after {
		display: none;
	}
`;

export const TooltipLabel = styled(Box)`
	z-index: 9000;
`;

export const TooltipBody = styled(Text)`
	white-space: pre-line;
	font-size: 0.85rem;
`;
